import React, { useState } from 'react';
import { useNotifications } from '../contexts/NotificationContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faBellSlash, faSpinner } from '@fortawesome/free-solid-svg-icons';

const NotificationPrompt = () => {
    const {
        notificationPermission,
        isSupported,
        isInitialized,
        isPermissionGranted,
        requestNotificationPermission,
        disableNotifications
    } = useNotifications();

    const [isLoading, setIsLoading] = useState(false);

    // Show loading state while the notification service is initializing
    if (!isInitialized) {
        return (
            <div className="alert alert-secondary d-flex align-items-center">
                <FontAwesomeIcon icon={faSpinner} className="me-2 fa-spin" />
                Checking notification support...
            </div>
        );
    }

    if (!isSupported) {
        console.log('---isSupported-->', isSupported);
        return (
            <div className="alert alert-warning">
                <FontAwesomeIcon icon={faBellSlash} className="me-2" />
                Notifications are not supported in this browser.
            </div>
        );
    }

    if (notificationPermission === 'denied') {
        return (
            <div className="alert alert-warning">
                <FontAwesomeIcon icon={faBellSlash} className="me-2" />
                Notifications are blocked. Enable them in your browser settings to receive updates.
            </div>
        );
    }

    // Handle the case where user has disabled notifications
    if (notificationPermission === 'disabled') {
        return (
            <div className="alert alert-info">
                <div className="mb-2">
                    <FontAwesomeIcon icon={faBellSlash} className="me-2" />
                    Notifications are currently disabled
                </div>
                <button
                    className="btn btn-sm btn-primary"
                    onClick={async () => {
                        setIsLoading(true);
                        try {
                            await requestNotificationPermission();
                        } catch (error) {
                            console.error('Failed to enable notifications:', error);
                        } finally {
                            setIsLoading(false);
                        }
                    }}
                    disabled={isLoading}
                >
                    {isLoading ? (
                        <>
                            <FontAwesomeIcon icon={faSpinner} className="me-1 fa-spin" />
                            Re-enabling...
                        </>
                    ) : (
                        'Re-enable Notifications'
                    )}
                </button>
            </div>
        );
    }

    if (isPermissionGranted) {
        return (
            <div className="alert alert-success d-flex justify-content-between align-items-center">
                <span>
                    <FontAwesomeIcon icon={faBell} className="me-2" />
                    Notifications are enabled
                </span>
                <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={disableNotifications}
                >
                    Disable
                </button>
            </div>
        );
    }

    const handleEnableNotifications = async () => {
        setIsLoading(true);
        try {
            await requestNotificationPermission();
        } catch (error) {
            console.error('Failed to enable notifications:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="alert alert-info">
            <div className="mb-2">
                <FontAwesomeIcon icon={faBell} className="me-2" />
                Stay updated with notifications
            </div>
            <button
                className="btn btn-sm btn-primary"
                onClick={handleEnableNotifications}
                disabled={isLoading}
            >
                {isLoading ? (
                    <>
                        <FontAwesomeIcon icon={faSpinner} className="me-1 fa-spin" />
                        Enabling...
                    </>
                ) : (
                    'Enable Notifications'
                )}
            </button>
        </div>
    );
};

export default NotificationPrompt;